import { Injectable } from '@angular/core';
import { DatiqMenuActions } from '../../../store';
import {
    IDatiqMenu,
    IDatiqMenuItem
} from '../models';
import {
    DATIQ_MENU_ITEM,
    DATIQ_MENU_TRIGGER,
    DatiqAnalyticsInputInteraction,
    datiqInputCreateId,
    IDatiqAnalyticsEvent,
    IDatiqAnalyticsEventInputInfo,
} from '@dat/datiq-core/models';
import { kebabCase } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class DatiqMenuMapperService {
    constructor() {}

    mapMenuTriggerEvent(settings: IDatiqMenu): IDatiqAnalyticsEvent {
        const eventName: string = this.mapMenuTriggerEventName();
        const inputInfo: IDatiqAnalyticsEventInputInfo =
            this.mapMenuTriggerEventInfo(settings);

        return {
            eventName,
            inputInfo,
        };
    }
    mapMenuTriggerEventName(): string {
        return DatiqMenuActions.clickedTriggerName;
    }
    mapMenuTriggerEventInfo(
        settings: IDatiqMenu
    ): IDatiqAnalyticsEventInputInfo {
        const inputId: string = this.mapMenuTriggerEventInfoId(settings);
        const interaction: DatiqAnalyticsInputInteraction =
            this.mapMenuTriggerEventInfoInteraction();
        const props: unknown = this.mapMenuTriggerEventInfoProps(settings);

        return {
            inputId,
            interaction,
            props,
        };
    }
    mapMenuTriggerEventInfoInteraction(): DatiqAnalyticsInputInteraction {
        return DatiqAnalyticsInputInteraction.Click;
    }
    mapMenuTriggerEventInfoProps(settings: IDatiqMenu): unknown {
        return !!settings?.trigger?.props ? settings?.trigger?.props : {};
    }
    mapMenuTriggerEventInfoId(settings: IDatiqMenu): string {
        return !!settings?.trigger?.id?.length
            ? settings?.trigger?.id
            : datiqInputCreateId([settings.id, DATIQ_MENU_TRIGGER]);
    }

    mapMenuItemEvent(
        menuItem: IDatiqMenuItem,
        settings: IDatiqMenu
    ): IDatiqAnalyticsEvent {
        const eventName: string = this.mapMenuItemEventName();
        const inputInfo: IDatiqAnalyticsEventInputInfo =
            this.mapMenuItemEventInfo(menuItem, settings);

        return {
            eventName,
            inputInfo,
        };
    }
    mapMenuItemEventName(): string {
        return DatiqMenuActions.clickItemName;
    }
    mapMenuItemEventInfo(
        menuItem: IDatiqMenuItem,
        settings: IDatiqMenu
    ): IDatiqAnalyticsEventInputInfo {
        const inputId: string = this.mapMenuItemEventInfoId(menuItem, settings);
        const interaction: DatiqAnalyticsInputInteraction =
            this.mapMenuItemEventInfoInteraction();
        const props: unknown = this.mapMenuItemEventInfoProps(menuItem);

        return {
            inputId,
            interaction,
            props,
        };
    }
    mapMenuItemEventInfoId(
        menuItem: IDatiqMenuItem,
        settings: IDatiqMenu
    ): string {
        return !!menuItem?.id?.length
            ? menuItem.id
            : datiqInputCreateId([
                  settings.id,
                  kebabCase(menuItem.label),
                  DATIQ_MENU_ITEM,
              ]);
    }
    mapMenuItemEventInfoInteraction(): DatiqAnalyticsInputInteraction {
        return DatiqAnalyticsInputInteraction.Click;
    }
    mapMenuItemEventInfoProps(menuItem: IDatiqMenuItem): unknown {
        return menuItem?.props;
    }
}
